export default __webpack_public_path__ + "static/media/block.a744a598.svg";